import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlService } from './url.service';

@Injectable()
export class FreepaymentService {
  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {}

  paymentLoan(
    amount: number,
    inn: number,
    contractNumber: number,
    url: string,
    scope: string,
    reCaptchaToken?: string,
    reason?: string,
    operationId?: number,
    phone?: number,
  ): Observable<any> {
    const body = {
      phone,
      amount,
      inn,
      contractNumber,
      url,
      operationId,
      reason,
      scope,
      reCaptchaToken,
    };
    return this.http.post(this.urlService.freepayment, body);
  }

  closedDocument(inn: number, contractNumber: number, reason: string, scope: string, reCaptchaToken?: string): Observable<any> {
    const body = {
      inn,
      contractNumber,
      reason,
      scope,
      reCaptchaToken,
    };
    return this.http.get(
      `${this.urlService.closedDocuments}?inn=${inn}&contractNumber=${contractNumber}&reason=${reason}&scope=${scope}&reCaptchaToken=${reCaptchaToken}`,
    );
  }

  closedDocumentDownload(inn: number, contractNumber: string, reason: string, scope: string, reCaptchaToken?: string): Observable<any> {
    const body = {
      inn,
      contractNumber,
      reason,
      scope,
      reCaptchaToken,
    };
    return this.http.get(
      `${this.urlService.closedDocumentsDownload}?inn=${inn}&contractNumber=${contractNumber}&reason=${reason}&scope=${scope}&reCaptchaToken=${reCaptchaToken}`,
      { responseType: 'blob' },
    );
  }
}
